import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/micrio.scss'

const app = createApp(App).use(router)

router.isReady().then(() => app.mount('#app'))
